import React from 'react';
import PropTypes from 'prop-types';

import Input from './input';
import LockableWrapper from './LockableWrapper';

const LockableInput = props => (
  <LockableWrapper disabled={props.disabled} hint={props.hint}>
    <Input {...props} />
  </LockableWrapper>
);

LockableInput.propTypes = {
  ...(Input.propTypes || {}),
  disabled: PropTypes.bool,
  hint: PropTypes.string,
};

LockableInput.defaultProps = {
  ...(Input.defaultProps || {}),
  disabled: false,
  hint: '',
};


export default LockableInput;
